import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/client";

import type { NewsSignalParams, NewsSignalResponse } from "./types";

const POLL_MS = 30_000;
const STALE_MS = 15_000;
const GC_MS = 5 * 60_000;

export function useNewsSignalQuery(params: NewsSignalParams) {
  return useQuery<NewsSignalResponse>({
    queryKey: [
      "material",
      params.material_id,
      "news-signal",
      params.timeframe,
      params.since,
      params.until ?? null,
      params.sources?.join(",") ?? null,
    ],
    queryFn: () => api.getMaterialNewsSignal(params),
    refetchInterval: POLL_MS,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    staleTime: STALE_MS,
    gcTime: GC_MS,
    retry: 2,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10_000),
  });
}
